export default __webpack_public_path__ + "static/media/img-services-header.394ffb9d.jpg";